"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 3,
    sm: 5,
    md: 8,
    lg: 12,
    xl: 16,
};
exports.default = react_jss_1.createUseStyles({
    progress: function (_a) {
        var radius = _a.radius, size = _a.size, theme = _a.theme;
        return ({
            height: theme_1.getSizeValue({ size: size, sizes: exports.sizes }),
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[2],
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
            overflow: 'hidden',
        });
    },
    bar: function (_a) {
        var theme = _a.theme, color = _a.color, radius = _a.radius, reduceMotion = _a.reduceMotion, striped = _a.striped;
        return ({
            height: '100%',
            backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
            transition: reduceMotion ? 'none' : "width 200ms " + theme.transitionTimingFunction,
            backgroundSize: [theme.spacing.md, theme.spacing.md],
            backgroundImage: striped
                ? 'linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)'
                : 'none',
        });
    },
}, { link: true });
